<template>
  <div class="notificationPage" ref="notificationPage">
    <div class="DetailMsg main">
      <h3>{{ baseData.title }}</h3>
      <div class="smallTit">
        <p class="smallTitTwo clearfix">
          <span v-if="this.baseData.author != ''" class="fl"
            >发布人：{{ baseData.sender ? baseData.sender : "" }}</span
          >
          <span class="fr" v-if="baseData.publishTime">{{
            baseData.publishTime.substr(0, 10)
          }}</span>
        </p>
      </div>
      <div class="detailInfo">
        <div
          v-html="baseData.content"
          v-if="baseData.contentType == 'text'"
          @click="imgChange($event)"
        ></div>
        <a
          :href="`${baseData.content}`"
          v-if="baseData.contentType == 'url'"
        ></a>
      </div>
    </div>
    <p class="fgx" v-if="JSON.stringify(this.baseData.baseAnnexes) != '[]'"></p>
    <div
      class="download main"
      v-if="JSON.stringify(this.baseData.baseAnnexes) != '[]'"
    >
      <h4 class="ggTit">附件</h4>
      <div class="detailMian">
        <ul>
          <li
            class="clearfix"
            v-for="item in baseData.baseAnnexes"
            :key="item.id"
          >
            <dl class="fl">
              <dt>
                <img
                  :src="
                    getFormat(item.fileName) == 'jpg' ||
                    getFormat(item.fileName) == 'png' ||
                    getFormat(item.fileName) == 'jpeg'
                      ? item.url
                      : getFormat(item.fileName) == 'pdf'
                      ? '' + baseUrl + 'searchImg/pdf.png'
                      : getFormat(item.fileName) == 'xlsx' ||
                        getFormat(item.fileName) == 'xls'
                      ? '' + baseUrl + 'searchImg/excel.png'
                      : '' + baseUrl + 'searchImg/word.png'
                  "
                  alt
                />
              </dt>
              <dd class="dtName">{{ item.fileName }}</dd>
              <dd class="Mb">
                <span>
                  {{ getMb(item.fileSize) }}
                  <span
                    v-if="baseData.createTime"
                    style="display: inline-block; margin-left: 15px"
                    >{{ baseData.createTime.substr(5) }}</span
                  >
                </span>
              </dd>
            </dl>
            <a
              href="javascript:void(0);"
              class="downloadBtn fr"
              @click="downLoad(item)"
              >下载</a
            >
          </li>
        </ul>
      </div>
    </div>
    <!-- 倒计时动画 -->
    <div :class="['countDown']" v-if="this.countDownShow">
      <van-circle
        class="countAnimation"
        v-model="currentRate"
        :rate="rate"
        speed="10"
        :clockwise="false"
        size="35"
        stroke-width="100"
        layer-color="#ccefe3"
        color="#6bc3a5"
        :text="countDownText"
      />
    </div>
    <wx-discuss-box :ktId="baseData.id" :allowComment="baseData.allowComment" />
    <van-image-preview
      v-model="magnifyImgShow"
      :images="magnifyImgs"
    ></van-image-preview>

    <van-overlay :show="weixnShow" @click="weixnShow = false">
      <div class="wrapper weixnPage" >
        <van-image :src="baseUrl + 'img/share.png'" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
/*eslint-disable*/
const wxDiscussBox = () => import("@/components/common/wxDiscussBox");
import nonePng from "@/assets/none.png";
import { mapState, mapMutations } from "vuex";
import { isIphonex } from "@/utils/common";
import { is_wei } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "wxInformMsg",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      appType: "",
      nonePng: nonePng, //默认图片
      iphonexType: "", //判断手机类型
      informId: "",
      orgId: "", //机构Id
      baseData: {},
      resultData: [],
      backstagelists: [],
      page: 0,
      pageSize: 10,
      commentCount: 0,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      isLoading: false, //是否处于下拉刷新状态
      mainText: [], //当前播放内容
      audioSrc: "",
      audioDuration: "", //播放时长
      currentTime: 0, //按当前播放时长
      playIndex: 0,
      timer: null,
      isPlaying: false, //是否播放
      countDownShow: false,
      currentRate: 100, //当前进度
      rate: 0, //目标进度
      countDownTime: 10,
      countDownText: "10s",
      magnifyImgShow: false, //放大图片
      magnifyImgs: [], //富文本发大图片
      countTimer: "",
      weixnShow: false, //微信下载遮罩层
    };
  },
  components: { wxDiscussBox },
  mounted() {
    document.title = "通知";
    this.informId = this.$route.query.commonId;
    this.orgId = this.$route.query.orgId;
    this.iphonexType = isIphonex();
    this.initPage();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      let _this = this;
      this.setShowLoad(false); //加载状态，默认为true加载
      _this.$api.baseCommon.Msg.infoMsg({
        id: _this.informId,
        type: "1",
      })
        .then((res) => {
          if (res.code == "1") {
            if (res.data != null) {
              _this.baseData = Object.assign({}, _this.baseData, res.data);
              if (_this.baseData.baseAnnexes.length > 0) {
                for (let i = 0; i < _this.baseData.baseAnnexes.length; i++) {
                  let fileLastName = "";
                  fileLastName = _this.getFormat(
                    _this.baseData.baseAnnexes[i].fileName
                  );
                  _this.$set(
                    _this.baseData.baseAnnexes[i],
                    "fileLastName",
                    fileLastName
                  );
                }
              }
              if (!_this.baseData.isRead) {
                _this.countDownShow = true;
                _this.countDown();
              }
            } else {
              _this.$toast("通知已被删除");
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    //放大富文本图片
    imgChange(e) {
      let imgs = [];
      this.baseData.content.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/g,
        function (match, capture) {
          imgs.push(capture);
        }
      );
      if (e.target.nodeName == "IMG") {
        let indexInfo = e.target.currentSrc;
        let showIndex = "";
        imgs.forEach((item, index) => {
          if (indexInfo == item) {
            showIndex = index;
          }
        });
        let data = {
          showImgs: imgs,
          swipercliclIndex: showIndex,
          swiperShow: true,
        };
        this.$store.commit("setDataImgs", data);
      } else {
        return;
      }
    },
    countDown() {
      let _this = this;
      if (parseInt(_this.countDownTime) > 1) {
        this.countTimer = setTimeout(function () {
          _this.countDownTime--;
          _this.countDownText = _this.countDownTime + "s";
          _this.countDown();
        }, 1000);
      } else {
        _this.countDownShow = false;
        _this.stoper();
        _this.readDetail();
      }
    },
    getMb(Kb) {
      let size = "";
      size = (Kb / 1024 / 1024).toFixed(4) + "MB";
      return size;
    },
    downLoad(data) {
      if (is_wei()) {
        //在微信内打开
        this.weixnShow = true;
      } else {
        let alink = document.createElement("a");
        alink.href = data.url;
        alink.download = data.fileName; //图片名
        alink.click();
      }
    },

    getFormat(name) {
      //获取文件后缀
      const _index = name.lastIndexOf(".");
      return _index >= 0 ? name.substring(_index + 1, name.length) : "";
    },
    readDetail() {
      let _this = this;
      _this.$api.baseCommon.Msg.infoRead({
        linkId: _this.informId,
        type: "notice",
      })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.$toast("已阅读");
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    stoper() {
      clearTimeout(this.countTimer);
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  beforeDestory() {
    this.stoper();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.notificationPage {
  width: 100%;
  .weixnPage {
    //微信下载遮罩层
    width: 100%;
    height: 100%;
    position: relative;
    .van-image {
      width: 80%;
      position: absolute;
      top: 5%;
      left: 15%;
    }
  }
  font-family: "PingFangSC-Regular";
  p.fgx {
    width: 100%;
    height: 20px;
    background-color: #f6f6f6;
  }
  .main {
    width: 100%;
    padding: 0 16px;
    margin: 0 auto;
    h4.ggTit {
      position: relative;
      border-bottom: 1px solid #f6f6f6;
      line-height: 45px;
      padding: 0 20px;
      font-weight: 700;
      color: #35c476;
      font-size: 14px;
      z-index: 10;
      background-color: #fff;
    }

    h4.ggTit:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 20px;
      background: #35c476;
      top: 12px;
      left: 10px;
      bottom: 5px;
    }
  }

  .smallTit {
    padding-bottom: 10px;
    border-bottom: 1px solid #4bc08a;

    p {
      margin-top: 5px;
      color: #999;
      span {
        font-size: 10px;
        line-height: 14px;
      }

      em {
        font-weight: normal;
      }
    }
  }

  .DetailMsg {
    margin-top: 20px;
    padding-bottom: 16px;
  }

  .DetailMsg h3 {
    font-size: 16px;
    font-family: "PingFangSC-Medium";
    font-weight: 600;
    color: #333;
    line-height: 25px;
    text-align: center;
  }

  .DetailTime {
    display: inline-block;
    margin-top: 12px;
    font-size: 13px;
    font-weight: 400;
    color: rgba(3, 3, 3, 1);
    line-height: 18px;
    opacity: 0.4;

    span {
      display: inline-block;
      margin-right: 4px;
    }
  }

  .DetailMsg {
    .detailInfo {
      margin: 30px 0 10px 0;
      position: relative;
      > div {
        img {
          width: 100%;
          height: 100%;
          margin: 0 auto;
          display: block;
        }

        p {
          margin-top: 18px;
          font-size: 14px;
          font-family: "PingFangSC-Regular";
          font-weight: 400;
          color: #666;
          line-height: 20px;
        }
      }
      .playerBox {
        position: absolute;
        top: -20px;
        right: 0;
        line-height: 20px;
        padding-left: 20px;
        i {
          position: absolute;
          display: inline-block;
          font-size: 16px;
          color: #35c476;
          left: 0;
          top: 2px;
        }
      }
      .playRadio {
        display: none;
      }
    }
  }

  .download {
    .detailMian {
      width: 100%;
      margin-top: 10px;

      li {
        width: 100%;
        min-height: 40px;
        margin: 8px 0;
        position: relative;
        dl {
          width: 85%;
          position: relative;

          dt {
            display: block;
            width: 40px;
            height: 40px;
            background-color: #f6f6f6;
            position: absolute;
            top: 50%;
            margin-top: -20px;
            img {
              width: 100%;
              height: 100%;
            }
          }

          dd {
            padding-left: 50px;
            display: block;
            font-size: 10px;
            color: #999;
          }

          dd.dtName {
            font-size: 12px;
            line-height: 16px;
            color: #666;
            margin-top: 8px;
          }
        }
      }

      a {
        display: block;
        font-size: 12px;
        color: #35c476;
        width: 30px;
        height: 30px;
        line-height: 30px;
        position: absolute;
        top: 50%;
        margin-top: -15px;
        right: 0;
      }
    }
  }

  .endReady {
    width: 100%;
    margin-top: 10px;

    .searchMain {
      width: 100%;
      height: 400px;
      overflow-y: scroll;
      //   background-color: #f6f6f6;
      position: relative;
      .resultList {
        width: 100%;
        .item {
          width: 100%;

          dl {
            width: 100%;
            min-height: 45px;
            position: relative;

            dt {
              display: block;
              width: 35px;
              height: 35px;
              border-radius: 50%;
              -webkit-border-radius: 50%;
              -moz-border-radius: 50%;
              background-color: #f6f6f6;
              position: absolute;
              img {
                display: block;
                max-width: 100%;
                border-radius: 50%;
                -webkit-border-radius: 50%;
                -moz-border-radius: 50%;
              }
            }

            dd {
              font-size: 10px;
              color: #999;
              position: absolute;
              top: 15px;
            }
            dd:nth-child(3) {
              left: 45px;
            }
            dd.time {
              right: 0;
            }
            dd.dtName {
              font-size: 12px;
              color: #666;
              top: 0;
              left: 45px;
            }
          }
        }
      }

      .nonePage {
        width: 120px;
        height: 150px;

        position: absolute;
        left: 50%;
        margin-left: -60px;
        top: 50%;
        margin-top: -75px;

        img {
          display: block;
          width: 117px;
          height: 122px;
          margin: 0 auto;
        }

        p {
          margin-top: 10px;
          text-align: center;
          color: #5c5d5d;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
    .searchMain.moreMian {
      height: 500px;
    }
  }

  .countDown {
    z-index: 99999;
    position: fixed;
    bottom: 80px;
    right: 10px;
    .countAnimation {
      border-radius: 50%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      background-color: #fff;
      .van-circle__text {
        color: #6bc3a5;
      }
    }
  }
}
</style>